
export default function caption(key) {
    key = key.replace(/[^\w\d_]/g, '_');
    return Mashie.Resources.GetString(key);
};
